export { default } from './Image';
export type { Props, Props as HeroBannerImageProps } from './Image';
